import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class AlertService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

  getId = (): string => 'alert';

  getTitle = (): string => 'Alert';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'alert/0', 'title': 'Alert Info', 'theme': 'layout1' },
      { 'url': 'alert/1', 'title': 'Alert Warning', 'theme': 'layout2' },
      { 'url': 'alert/2', 'title': 'Alert Subscribe', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Alert Info',
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': '8 km to center',
          'price': '$ 340 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'title': 'Encore Macau',
          'subtitle': '8 km to center',
          'price': '$ 200 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'title': 'Bulgari Hotel London',
          'subtitle': '8 km to center',
          'price': '$ 500 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'title': 'Belmond El Encanto',
          'subtitle': '8 km to center',
          'price': '$ 100 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'title': 'The Alpina Gstaad',
          'subtitle': '8 km to center',
          'price': '$ 600 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Alert Warning',
      'items': [
        {
          'id': 1,
          'title': '45 Park Lane',
          'subtitle': '8 km to center',
          'price': '$ 340 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/8.jpg',
        },
        {
          'id': 2,
          'title': 'Encore Macau',
          'subtitle': '8 km to center',
          'price': '$ 200 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/9.jpg',
        },
        {
          'id': 3,
          'title': 'Bulgari Hotel London',
          'subtitle': '8 km to center',
          'price': '$ 500 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'title': 'Belmond El Encanto',
          'subtitle': '8 km to center',
          'price': '$ 100 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'title': 'The Alpina Gstaad',
          'subtitle': '8 km to center',
          'price': '$ 600 /per month',
          'rating': '8.4 /85 reviews',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Alert Subscribe',
      'items': [
        {
          'id': 1,
          'image': 'assets/imgs/background/1.jpg',
          'time': 'MARCH 14, 2017',
          'title': 'The Lowell, New York City',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum.',
        },
        {
          'id': 2,
          'image': 'assets/imgs/background/2.jpg',
          'time': 'MARCH 14, 2017',
          'title': 'The Milestone Hotel, London',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum.',
        },
        {
          'id': 3,
          'image': 'assets/imgs/background/3.jpg',
          'time': 'MARCH 14, 2017',
          'title': 'Lebua at State Tower, Bangkok',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum.',
        },
        {
          'id': 4,
          'image': 'assets/imgs/background/4.jpg',
          'time': 'MARCH 14, 2017',
          'title': 'Katikies Hotel, Santorini, Greece',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum.',
        }
      ]
    };
  }

  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('alert/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
